<div class="incident-created-successfully-dialog">
    <app-popup-top-line class="upper-line"></app-popup-top-line>
    <div class="incident-created-successfully-dialog-header">
        <div class="title">
            <div class="description">
                {{ dynamicSentence || "Incident created successfully in Microsoft Sentinel." }}
            </div>
        </div>
        <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
    </div>

    <br /><br /><br />
    <div class="incident-created-successfully-dialog-footer">
        <div class="incident-created-successfully-dialog-buttons-container">
            <button class="incident-created-successfully-dialog-button" (click)="onClose()">CONTINUE</button>
        </div>
    </div>
</div>
